module.exports = __webpack_public_path__ + "static/media/Wallet Reports.6c2b576b.png";